import 'flickity/dist/flickity.pkgd';

export default {
  init() {
    // HAMBURGER
    $('.hamburger').click(function() {
      $(this).toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    $('.hamburger-bg').click(function() {
      $('.hamburger').toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    // HAMBURGER
    $('.mobile-nav ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.mobile-nav ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });

    // SCROLLED
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 1) {
        $('body').addClass('scrolled');
      }
      else {
        $('body').removeClass('scrolled');
      }
    });
  },
  finalize() {

    // COOKIES
    function setCookieVisited() {
      $('.view__works').click(function(){
        $('body').addClass('close__popup');
        document.cookie = 'approved' + '=' + 'true' + ';expires=;path=/';
      });
    }

    // Check if cookie exist
    if( document.cookie.indexOf('approved') <= -1 ){
      setTimeout( function(){
          setCookieVisited();
      });
    }

    // RANDOM WORD
    var words = $('.randomword').length;
    function fadeWords(nr) {
      if (nr == words) {
        fadeWords(0);
      } else {
        $('.randomword').eq(nr).addClass('active');
        setTimeout(function() {
          $('.randomword').eq(nr).removeClass('active');
          fadeWords(nr+1);
        }, 800);
      }
    }

    // RANDOM WORD
    if($('.randomword').length) {
      fadeWords(0);
    }

    // NAV SELECTOR
    var lastId,
        topMenu = $('nav.fixed'),
        topMenuHeight = topMenu.outerHeight(),
        menuItems = topMenu.find('a:not([rel="nofollow"])'),
        scrollItems = menuItems.map(function(){
          var item = $($(this).attr('href'));
          if (item.length) { return item; }
        });

    // Bind to scroll
    $(window).scroll(function(){
       // Get container scroll position
       var fromTop = $(this).scrollTop()+topMenuHeight;

       // Get id of current scroll item
       var cur = scrollItems.map(function(){
         if ($(this).offset().top < fromTop)
           return this;
       });
       // Get the id of the current element
       cur = cur[cur.length-1];
       var id = cur && cur.length ? cur[0].id : '';

       if (lastId !== id) {
           lastId = id;
           // Set/remove active class
           menuItems
             .parent().removeClass('active')
             /* eslint-disable */
             .end().filter("[href='#"+id+"']").parent().addClass('active');
             /* eslint-enable */
       }
    });

    $('.js-cursor-drag').mouseover(
      function() {
        $('body').attr('data-cursor', 'drag');
      }
    ).mouseleave(
      function() {
        $('body').attr('data-cursor', 'normal');
      }
    );

    const cursor = document.querySelector('.cursor');
    const cursorListener = (event) => {
      cursor.style.top = event.y + 'px';
      cursor.style.left = event.x + 'px';
    }

    window.addEventListener('mousemove', cursorListener);


    // init Flickity slidingimages
    if($('.slider').length) {
      $('.slider').each(function() {
        $(this).flickity({
          pageDots: true,
          wrapAround: false,
          cellAlign: 'left',
          initialIndex: 0,
          percentPosition: false,
          lazyLoad: true,
          draggable: true,
          freeScroll: false,
          friction: 0.8,
          selectedAttraction: 0.2,
          imagesLoaded: true,
          prevNextButtons : false,
        });

        $(this).on( 'dragMove.flickity', function( event ) {
          cursor.style.top = event.originalEvent.y + 'px';
          cursor.style.left = event.originalEvent.x + 'px';
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js